<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/meal-product"
    entity-name="餐品"
    add-btn="新增"
    hide-show-detail
    :before-update="beforeUpdate"
    :hide-action="!editable"
    :modal-width="600"
    :modal-form="modalForm"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules">
    <template v-slot:edit="{form}">
      <a-form-model-item label="餐品名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入餐品名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="餐品英文名称" prop="english_name">
        <a-input v-model="form.english_name" placeholder="请输入餐品英文名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="图片" prop="img">
        <cl-upload v-model="form.img"></cl-upload>
      </a-form-model-item>
      <a-form-model-item label="价格" prop="price">
        <a-input-number :min="0" v-model="form.price" placeholder="请输入餐品价格" style="width: 100%"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="描述（中文）" prop="describe">
        <a-textarea v-model="form.describe" placeholder="请输入" :rows="4"></a-textarea>
      </a-form-model-item>
      <a-form-model-item label="描述（英文）" prop="english_describe">
        <a-textarea v-model="form.english_describe" placeholder="请输入" :rows="4"></a-textarea>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import mixins from "../mixins";

    export default {
        name: "FoodType",
        data() {
            return {
                dateList: [],
                timeList: [],
                columns: [
                    {title: '餐品名称', dataIndex: 'name'},
                    {title: '图片', dataIndex: 'img', customRender: text => <s-img src={text} />},
                    {title: '价格', dataIndex: 'price'},
                    {title: '描述（中文）', dataIndex: 'describe', customRender: text => text ? text.split(/\n|s/).map(p => <div>{p}</div>) : "--"},
                    {title: '描述（英文）', dataIndex: 'english_describe', customRender: text => text ? text.split(/\n|s/).map(p => <div>{p}</div>) : "--"},
                ],
                rules: {
                    meal_date: [{ required: true, message: '请选择订餐日期', trigger: 'change' }],
                    meal_time: [{ required: true, message: '请选择订餐时间', trigger: 'change' }],
                    name: [{ required: true, message: '请输入餐品名称', trigger: 'blur' }],
                    english_name: [{ required: true, message: '请输入餐品英文名称', trigger: 'blur' }],
                    img: [{ required: true, message: '请上传餐品图片', trigger: 'change' }],
                    price: [{ required: true, message: '请输入餐品价格（人民币）', trigger: 'blur' }],
                    english_price: [{ required: true, message: '请输入餐品价格（美元）', trigger: 'blur' }],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'food-type',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        created() {
            this.getFoodSet();
        },
        methods: {
            getFoodSet() {
                let url = "/activity/meal-set?pageSize=1";
                if (this.activity) {
                    url += `&filter[activity_id]=${this.activity.id}`
                }
                this.$axios(url).then(res => {
                    if (res.data.length > 0) {
                        const config = res.data[0];
                        if (config.meal_date) {
                            this.dateList = config.meal_date.split(",").map(item => {
                                return { value: item, label: item };
                            });
                        }
                        if (config.meal_time) {
                            this.timeList = config.meal_time.split(",").map(item => {
                                return { value: item, label: item };
                            });
                        }
                    }
                })
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
